export const DEFAULT_FFL = 12.0;
export const DEFAULT_OSC = 20;
export const DEFAULT_OSH = 5;



// WEBPACK FOOTER //
// ./src/utils/behaviour_models/mallee_heath/constants.js